import { render, staticRenderFns } from "./AlertMessages.vue?vue&type=template&id=83f039c0&"
import script from "./AlertMessages.vue?vue&type=script&lang=js&"
export * from "./AlertMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports